import { cookie } from '@pdrj/pmi-iqos-shared-react'

export default class IqosphereQuest {
  constructor(api) {
    this.api = api
  }

  validateQuest = async dataToValidate => {
    const res = await this.api.post('/iqosphere/quest/validate', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      mock: this.api.getMock('getQuestValidation'),
      data: dataToValidate
    })
    return res
  }

  submitQuest = async (questData, questId) => {
    const res = await this.api.post('/iqosphere/quest?rpc=true', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      mock: this.api.getMock('getQuestSubmit'),
      useProxy: true,
      withCredentials: true,
      data: {
        ...questData,
        id: questId
      }
    })
    return res
  }

  getQuest = async questId => {
    const res = await this.api.get('/iqosphere/quest/' + questId, {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      mock: this.api.getMock('getQuest')
    })
    return res
  }

  getQuestDetail = async questId => {
    const res = await this.api.get('/iqosphere/quest/' + questId + '/detail', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      mock: this.api.getMock('getQuestDetail')
    })
    return res
  }

  getQuestList = async () => {
    const res = await this.api.get('/iqosphere/quest', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      mock: this.api.getMock('getQuestList')
    })
    return res
  }

  deleteQuestNotice = async () => {
    const res = await this.api.delete('/iqosphere/quest/track', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      mock: this.api.getMock('getQuestValidation')
    })
    return res
  }
}
